<div class="d-flex-center m-t-20" *ngIf="!sale?.coupon" @fadeInOut>
    <img src="assets/images/spinner1.gif" width="70">
</div>
<ng-container *ngIf="sale?.coupon">
    <div class="p-10 p-b-0" @fadeInOut>
        <ng-container *ngIf="actionOption == 1 || actionOption == 2">
            <!-- Givi Solo para regalo -->
            <ng-container *ngIf="sale.isForGift">
                <div class="qr-shadow p-16">
                    <div class="d-flex-center m-t-20 m-b-10 p-20" style="background-color: #EEF5F9; border-radius: 8px;">
                        <img src="assets/images/soloregalocanje.png" style="width: 100%;">
                    </div>
                </div>
            </ng-container>
            <div class="text-center m-t-20 font-14"><b>Cupón: </b> {{sale?.coupon?.name}}</div>
            <!-- Givi normal -->
            <div *ngIf="!sale.isForGift"> 
                <div *ngIf="wantToRedeem" @fadeInOut> 
                    <!-- Código QR/Bar -->
                    <div class="qr-shadow p-16 p-t-0" id="targetDiv">
                        <div class="d-flex-center" *ngIf="!showBarcode">
                            <qrcode [elementType]="'img'" [qrdata]="sale.qrCode + '/' + token" [margin]="-10" [width]="200"></qrcode>
                        </div>
                        <div class="d-flex-center container-barcode m-b-10" *ngIf="showBarcode">
                            <svg id="barcode"></svg>
                        </div> 
                        <div class="d-flex-center">
                            <div class="font-14">Código: <b>{{sale.qrCode}}</b></div>
                            <div class="m-l-30">
                                <div class="font-14">Token: <b>{{token}}</b></div>
                                <ngb-progressbar type="primary" height="8px" [value]="currentTokenTimerValue" [max]="currentTokenTimerMax"></ngb-progressbar>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Want to redeem? -->
                <ng-container *ngIf="!wantToRedeem"> 
                    <div class="d-flex-center m-t-20" style="position: relative;" (click)="onChangeWantToRedeem()">
                        <img src="assets/images/qrblurgivis.png" width="160" style="opacity: 0.5;">
                        <div class="btn-dark-custom" style="position: absolute; top: 42%; width: 140px; padding: 8px 14px !important;">
                            <i class="mdi mdi-eye-outline font-18 mr-2"></i>Ver {{!showBarcode ? 'Qr' : 'Código'}}
                        </div>
                    </div>
                </ng-container>
            </div>
        </ng-container>
        <!-- Send -->
        <ng-container *ngIf="actionOption == 3">
            <app-send-givi [sale]="sale"></app-send-givi>
        </ng-container> 
        <!-- Options -->
        <div class="d-flex-center m-t-20">
            <div class="text-center" (click)="onChangeOption(1)" [ngClass]="actionOption == 1 ? 'btn-action-active' : 'btn-action'">
                <i class="mdi mdi-qrcode" style="font-size: 24px;"></i>
                <div class="font-12" style="margin-top: -8px;">QR</div>
            </div>
            <div class="text-center m-l-10" (click)="onChangeOption(2)" [ngClass]="actionOption == 2 ? 'btn-action-active' : 'btn-action'">
                <i class="mdi mdi-barcode" style="font-size: 24px;"></i>
                <div class="font-12" style="margin-top: -8px;">Barras</div>
            </div>
            <div *ngIf="!sale.isForOwner" class="text-center m-l-10" (click)="onChangeOption(3)" [ngClass]="actionOption == 3 ? 'btn-action-active' : 'btn-action'">
                <i class="mdi mdi-gift-outline" style="font-size: 24px;"></i>
                <div class="font-12" style="margin-top: -8px;">Regalar</div>
            </div>
            <div *ngIf="false" class="text-center m-l-10" (click)="onChangeOption(4)" [ngClass]="actionOption == 4 ? 'btn-action-active' : 'btn-action'">
                <i class="mdi mdi-download-outline" style="font-size: 24px;"></i>
                <div class="font-12" style="margin-top: -8px; margin-left: -2px;">Descargar</div>
            </div>
        </div>
        <!-- Details -->
        <ng-container *ngIf="!showMoreDetails">
            <div class="d-flex-center text-muted m-t-20" (click)="showMoreDetails = true">
                <div class="font-14">Más detalles</div>
                <i class="mdi mdi-arrow-down font'18"></i>
            </div> 
        </ng-container>
        <div *ngIf="showMoreDetails" @fadeInOut>
            <div class="d-flex-center text-muted m-t-20" (click)="showMoreDetails = false">
                <div class="font-14">Menos detalles</div>
                <i class="mdi mdi-arrow-up font'18"></i>
            </div>
            <!-- Cliente -->
            <div class="border-top p-t-10 m-t-10">
                <div class="d-flex-between">
                    <div class="font-14 font-bold">Regalo para: </div>
                    <div (click)="showGiviNote(sale.transactionNotes, sale.id, sale.customerOwnerId,sale.isExpired)" >
                        <div class="mr-auto tag" *ngIf="sale.transactionNotes == null">Regalo para</div>
                        <div class="mr-auto tag" *ngIf="sale.transactionNotes != null" [ngStyle]="{'background-color':sale.transactionNotes.color, 'color':'#ffffff'}">
                            {{sale.transactionNotes.note.length > 12? sale.transactionNotes.note.slice(0,9) + '...': sale.transactionNotes.note}}
                        </div>
                    </div>
                </div> 
            </div>
            <!-- Vence -->
            <div class="border-top p-t-10 m-t-10">
                <div class="d-flex-between">
                    <div class="font-14 font-bold">Vencimiento: </div>
                    <div class="font-14">{{sale.expirationAt | date: 'dd MMMM yyyy'}}</div>
                </div>
            </div>
            <!-- Price -->
            <div class="border-top p-t-10 m-t-10" *ngIf="sale.total > 0">
                <div class="d-flex-between">
                    <div class="font-14 font-bold">Precio: </div>
                    <div class="font-14 font-bold">{{sale.total | currency: sale?.currencySymbol : 'symbol': '3.0'}} </div>
                </div>
            </div>
            <!-- Description -->
            <div class="border-top p-t-10 m-t-10">
                <div class="d-flex-between">
                    <div class="font-14 font-bold">Descripción: </div>
                    <div>
                        <small *ngIf="!showDescription" class="font-14 m-t-8 font-bold" (click)="showDescription = true" style="text-decoration: underline;">Ver más</small>
                        <small *ngIf="showDescription" class="font-14 m-t-8 font-bold" (click)="showDescription = false" style="text-decoration: underline;"><b>Ocultar</b></small>
                    </div>            
                </div>
                <div *ngIf="showDescription">
                    <p class="font-12" [innerHTML]="sale.productDescription"></p>
                </div>  
            </div>
            <!-- Terms -->
            <div class="border-top p-t-10 m-t-10">
                <div class="d-flex-center font-14 font-bold" style="text-decoration: underline;" (click)="onViewTerms(saleModal)">Ver términos y condiciones</div>
            </div>
            <!-- Store Names -->
            <div class="m-t-20">
                <app-smart-list-store [stores]="vendorStores"></app-smart-list-store>
            </div>
            <div class="text-center"> 
                <app-delete-transaction [transaction]="sale"></app-delete-transaction>
            </div>
        </div>
    </div>
</ng-container>

<ng-template #saleModal let-modal>
    <div class="modal-body">

        <div>
            <button class="close" (click)="modal.dismiss()">
                <i class="fa fa-times m-t-5 m-r-10"></i>
            </button>
        </div>

        <div class="border-bottom">
            <div class="text-center m-t-5 m-b-8">
                <span class="m-l-10 font-b2">Términos y condiciones</span>
            </div>
        </div>

        <div class="p-b-20">

            <div class="m-t-20 text-center font-b1">
                {{sale.coupon.name}}
            </div>

            <div class="m-t-20 text-center">
                <div class="font-c1" [innerHTML]="sale.coupon.terms"></div>
            </div>

            <!-- button submit -->
            <div class="d-flex-center m-t-20">
                <button class="btn-dark-custom" (click)="modal.dismiss()">Cerrar</button>
            </div>
        </div>
    </div>
</ng-template>

<app-givi-note-modal [giviNote]="giviNote" [transactionId]="transactionId" [customerOwnerId]="customerOwnerId" [countryNote]="country" (onUpdateNote)="onUpdateNote($event)"></app-givi-note-modal>

<!-- Success Redeemed -->
<ng-container *ngIf="showSuccess">
    <app-redeemed-success (closeSuccess)="onCloseSuccess()"></app-redeemed-success>
</ng-container>
